import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email:'', password:'' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async e => {
    e.preventDefault();
    setLoading(true); setError('');
    const { error } = await supabase.auth.signInWithPassword({ email: form.email, password: form.password });
    if (error) setError(error.message);
    setLoading(false);
  };

  const inputStyle = { width:'100%', padding:'13px 16px', background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'12px', color:'white', fontSize:'0.9rem', outline:'none' };

  return (
    <div style={{ minHeight:'100vh', background:'#080808', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' }}>
      <div style={{ width:'100%', maxWidth:'380px', animation:'fadeIn 0.4s ease' }}>
        <div style={{ textAlign:'center', marginBottom:'32px' }}>
          <div onClick={() => navigate('/')} style={{ fontSize:'1.5rem', fontWeight:700, letterSpacing:'-0.5px', color:'white', marginBottom:'6px', cursor:'pointer' }}>
            near<span style={{ color:'rgba(255,255,255,0.3)' }}>me</span>
          </div>
          <p style={{ color:'rgba(255,255,255,0.3)', fontSize:'0.88rem' }}>Welcome back</p>
        </div>

        <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'22px', padding:'28px' }}>
          {error && <div style={{ background:'rgba(255,50,50,0.08)', border:'1px solid rgba(255,50,50,0.15)', borderRadius:'10px', padding:'11px', color:'#ff6b6b', marginBottom:'16px', fontSize:'0.83rem' }}>{error}</div>}

          <form onSubmit={handleLogin} style={{ display:'flex', flexDirection:'column', gap:'13px' }}>
            <input type="email" placeholder="Email address" value={form.email} onChange={e => setForm({...form, email:e.target.value})} required style={inputStyle}/>
            <input type="password" placeholder="Password" value={form.password} onChange={e => setForm({...form, password:e.target.value})} required style={inputStyle}/>
            <button type="submit" disabled={loading} style={{ padding:'14px', background:'white', color:'#080808', border:'none', borderRadius:'12px', fontSize:'0.95rem', fontWeight:600, cursor:'pointer', opacity: loading?0.7:1, marginTop:'4px' }}>
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>
        </div>

        <p style={{ textAlign:'center', color:'rgba(255,255,255,0.25)', marginTop:'18px', fontSize:'0.85rem' }}>
          No account?{' '}
          <span onClick={() => navigate('/signup')} style={{ color:'white', cursor:'pointer', fontWeight:500 }}>Create one</span>
        </p>
      </div>
    </div>
  );
}
